import _ from '@lodash';
import { IconButton, withStyles } from '@material-ui/core';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import clsx from 'clsx';
import React from 'react';
import ImageUploadResizer from 'react-form-upload-image-resize';
import { GoCloudUpload } from 'react-icons/go';
import { MdDelete } from 'react-icons/md';

const styles = theme => ({
    root: {
        width: 150,
        height: 150,
        border: "1px solid " + theme.palette.divider,
        borderRadius: 5
    },
    Botao: {
        display: 'inline-block',
        padding: '6px 6px',
        cursor: 'pointer',
        borderRadius: "4px",
        color: theme.palette.text.primary,
    },
    imgClass: {
        maxHeight: "100%",
        maxWidth: "100%",
        width: "auto",
        height: "auto",
        position: "absolute",
        top: "0",
        bottom: "0",
        left: "0",
        right: "0",
        margin: "auto",
    }
});

class ImageUploader extends XAPPComponent {

    handleChangeBase64 = (_AImage) => {
        if (typeof _AImage !== "string") {
            _AImage = null;
        }
        this.props.onChange(_AImage, this.props.name);
    };

    handleChangeFile = (ev) => {
        let AFile = ev.target.files[0];
        var AReader = new FileReader();
        AReader.readAsDataURL(AFile);
        AReader.onload = function () {
            this.handleChangeBase64(AReader.result);
        }.bind(this);
    }

    render() {
        const { image = null, showtoolbar, classes, disabled, name, key, resizeImage = true } = this.props;
        const time = new Date().getTime();
        return (
            <div className={classes.root} key={key}>
                <div style={{ height: "70%", width: "100%", position: "relative" }}>
                    <img className={classes.imgClass}
                        src={!_.isNull(image) && typeof image === "string" && image.length > 0 ? image : "assets/images/avatars/profile.png"}
                    />
                </div>
                {showtoolbar === true &&
                    <div className="flex items-center justify-center" style={{ height: "30%" }}>
                        <IconButton
                            component={"label"}
                            for={"file-upload-" + name + "_" + time}
                            className={classes.Icon}
                            onClick={this.handleChangeBase64.bind(this)}
                            disabled={disabled}
                        >
                            <GoCloudUpload className="text-20" color="textSecondary" />
                        </IconButton>
                        {resizeImage ?
                            <ImageUploadResizer
                                id={"file-upload-" + name + "_" + time}
                                name={"file-upload-" + name + "_" + time}
                                change={this.handleChangeBase64.bind(this)}
                                width={100}
                                height={100}
                                classes={clsx(classes.Botao, "hidden")}
                            >
                            </ImageUploadResizer>
                            :
                            <input
                                className={clsx(classes.Botao, "hidden")}
                                id={"file-upload-" + name + "_" + time}
                                name={"file-upload-" + name + "_" + time}
                                onChange={this.handleChangeFile}
                                type="file"
                            />
                        }
                        <IconButton
                            className={classes.Icon}
                            onClick={this.handleChangeBase64.bind(this)}
                            disabled={disabled}
                        >
                            <MdDelete className="text-20" color="textSecondary" />
                        </IconButton>
                    </div>
                }
            </div>
        );
    }
}

export default (withStyles(styles, { withTheme: true })(ImageUploader));